import { render, staticRenderFns } from "./delPopup.vue?vue&type=template&id=e84e07d0"
import script from "./delPopup.vue?vue&type=script&lang=js"
export * from "./delPopup.vue?vue&type=script&lang=js"
import style0 from "./delPopup.vue?vue&type=style&index=0&id=e84e07d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports